// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__09TXz","breadcrumb":"Breadcrumbs_breadcrumb__0YFlz","icon":"Breadcrumbs_icon__aiW3I"};